<ul>
    <li *ngFor="let language of sortedLanguages"
        [class.current]="language === current"
        (click)="onClickOnLanguage( language )">{{ language }}</li>
</ul>
